import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const HeaderComp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const phone = "+971559215470";
  const whatsappLink = `https://wa.me/${phone}`;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const pathname = location.pathname;

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 text-white transition-all duration-500 ${isScrolled
        ? "bg-black/60 backdrop-blur-[4px] shadow-lg"
        : "bg-white/10 backdrop-blur-[2px] shadow-md"
        }`}
    >
      <div
        className={`flex justify-between items-center px-6 sm:px-10 md:px-14 lg:px-20 transition-all duration-500 overflow-hidden ${isScrolled ? "max-h-0 opacity-0" : "max-h-10 opacity-100 py-5"
          }`}
      >
        <p className="text-[11px]">
          Call Us:{" "}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#ff9219] no-underline"
          >
            +971-55-9215470
          </a>
        </p>
        <div className="flex items-center gap-4">
          <a href="https://www.facebook.com/bonvoytourism" target="_blank" rel="noreferrer">
            <img src="/images/header/facebook.png" alt="fb" width={18} height={18} />
          </a>
          <a href="https://www.instagram.com/bonvoytourism" target="_blank" rel="noreferrer">
            <img src="/images/header/insta.png" alt="insta" width={18} height={18} />
          </a>
          <a href="https://www.tripadvisor.com/Attraction_Review-g295424-d29787943-Reviews-Bonvoy_Tourism-Dubai_Emirate_of_Dubai.html" target="_blank" rel="noreferrer">
            <img src="/images/header/tripadvisor.png" className="pt-[10px]" alt="x" width={24} height={24} />
          </a>
        </div>
      </div>

      {!isScrolled && <div className="w-full h-[1px] bg-[rgba(255,255,255,0.3)] mb-2"></div>}

      <div className="flex justify-between items-center px-6 sm:px-10 md:px-14 lg:px-20 py-4">
        <Link to="/">
          {/* <img src="/images/header/bonvoy-touris.webp" alt="logo" width={150} height={70} /> */}
          <img src="/images/header/logo.png" alt="logo" width={50} height={50} />
        </Link>

        <nav className="hidden lg:flex items-center gap-12 text-[13px] font-medium">
          {[
            { path: "/", label: "Home" },
            { path: "/about", label: "About" },
            { path: "/gallery", label: "Gallery" },
            { path: "/tour", label: "Tours" },
            { path: "/services", label: "Services" },
            { path: "/contactus", label: "Contact" },
          ].map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`transition-colors duration-300 ease-in-out ${pathname === link.path ? "text-[#ff9219]" : "hover:text-[#ff9219]"
                }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          className="lg:hidden p-2"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isOpen && (
        <div className="lg:hidden my-4 flex flex-col gap-4 text-[14px] font-medium bg-white/10 backdrop-blur-lg rounded-lg p-4 mx-6">
          {[
            { path: "/", label: "Home" },
            { path: "/about", label: "About" },
            { path: "/gallery", label: "Gallery" },
            { path: "/tour", label: "Tours" },
            { path: "/services", label: "Services" },
            { path: "/contactus", label: "Contact" },
          ].map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsOpen(false)}
              className={`transition-colors duration-300 ease-in-out ${pathname === link.path ? "text-[#ff9219]" : "hover:text-[#ff9219]"
                }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default HeaderComp;
